import React from 'react';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

interface IIconCatering {
  height?: string;
  fill?: string;
}
const IconCatering = (props: IIconCatering) => (
  <svg viewBox="0 0 90 72" {...props}>
    <title>Catering</title>
    <path
      d="M18 0c9.941 0 18 8.06 18 18s-8.059 18-18 18S0 27.94 0 18 8.059 0 18 0zm32.963 44.106H69c-1.863 3.436-10.979 5.007-10.979 5.007l-11.37 15.12s-.98 1.561-3.072 1.734l.033.033H4s2.992-27 12.556-27c9.566 0 26.86 14.923 26.86 14.923l7.547-9.72v-.097zM61.315 22h1.142c13.581 0 16.206 13.73 16.206 13.73 1.712 0 4.109.432 4.337 3.243C83 41.676 79.12 42 79.12 42H44.88S41 41.676 41 38.973c0-2.703 2.397-3.243 4.109-3.243 0 0 2.625-13.73 16.206-13.73zm2.749-5c.515 0 .936.45.936 1s-.42 1-.936 1h-6.126c-.516 0-.938-.45-.938-1s.422-1 .938-1h6.126z"
      fillRule="evenodd"
    />
  </svg>
);

export default IconCatering;
